import { useQuery } from "react-query";
import getActiveNotes from "../services/getActiveNotes";

const useActiveNotes = (token: string) => {
  return useQuery(["active-notes"], () => getActiveNotes(token), {
    enabled: !!token,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: false,
  });
};

export default useActiveNotes;
